import React from 'react';

/**
 * Global React error boundary — catches render/lifecycle errors.
 * Displays a fallback UI with retry/reload options.
 */
export class ErrorBoundary extends React.Component {
  constructor (props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError (error) {
    return { hasError: true, error };
  }

  componentDidCatch (error, info) {
    console.error('ErrorBoundary caught:', error, info?.componentStack);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  render () {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '2rem',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
          background: '#0f0f0f',
          color: '#e5e5e5'
        }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>
            Что-то пошло не так
          </h2>
          <p style={{ color: '#a3a3a3', marginBottom: '1.5rem', maxWidth: 480, textAlign: 'center' }}>
            {this.state.error?.message || 'Неизвестная ошибка приложения'}
          </p>
          <div style={{ display: 'flex', gap: '0.75rem' }}>
            <button
              onClick={this.handleReset}
              style={{
                padding: '0.5rem 1rem',
                borderRadius: '6px',
                border: '1px solid #404040',
                background: '#262626',
                color: '#e5e5e5',
                cursor: 'pointer',
                fontSize: '0.875rem'
              }}
            >
              Попробовать снова
            </button>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: '0.5rem 1rem',
                borderRadius: '6px',
                border: 'none',
                background: '#3b82f6',
                color: '#fff',
                cursor: 'pointer',
                fontSize: '0.875rem'
              }}
            >
              Перезагрузить
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
